<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
export default
{
    name: 'mv-supporter-form',

    computed:
    {
        ...mapGetters({
            locale: 'generalCurrentLocale',
        }),

        categoryValue()
        {
            return this.categories.findByModelId(this.model.supporter_category_id)
        },

    },

    methods:
    {
        save()
        {
            this.$emit('save')
        },

        submit()
        {
            this.$refs.form.submit()
        },

        addFile(file)
        {
            this.model.attachments.push(file)
        },

        removeFile(file)
        {
            for (let i = 0; i < this.model.attachments.length; ++i)
            {
                const item = this.model.attachments[i]
                if (file.id == item.id)
                {
                    this.model.attachments.splice(i, 1)
                }
            }

        },

        categoryChange(val)
        {
            if (val && val.id)
                this.model.supporter_category_id = val.id
        },
    },

    props:
    {
        model: Object,
        edit: Boolean,
    },

    data()
    {
        return {
            categories: [],
        }
    },

    mounted()
    {
        axios.get(process.env.API_URL + '/v1/admin/supportercategories').then(res => {
            this.categories = res.data
        }).catch(e => {})
    },

}
</script>

<template>
<div class="container">
    <form @submit.prevent.stop="save" ref="form">
        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('GENERAL.LINK') }}
            </label>
            <div class="col-md-6">
                <input type="text" class="form-control" v-model="model.link">
            </div>
        </div>

        <div class="form-group row" v-if="false">
            <label for="name" class="col-md-4 control-label">
                {{ $t('ARTIST.CATEGORIES') }}
            </label>
            <div class="col-md-6">
                <v-select :options="categories" :value="categoryValue" @input="categoryChange" label="name" :clearable="false">
                </v-select>
            </div>
        </div>

        <div class="form-group row">
            <label for="order" class="col-md-4 control-label">
                {{ $t('MENUS.ORDER') }}
            </label>
            <div class="col-md-6">
                <input type="number" class="form-control" v-model="model.order" >
            </div>
        </div>


        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('MENUS.ACTIVE') }}
            </label>
            <div class="col-md-6">
                <input type="checkbox" v-model="model.is_active">
            </div>
        </div>

        <div class="form-group row" v-if="false">
            <label class="col-md-4 control-label">
                {{ $t('POST.IS_FOOTER') }}
            </label>
            <div class="col-md-6">
                <input type="checkbox" v-model="model.is_footer">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.IMAGE') }}
            </label>
            <div class="col-md-6 text-center">
                <mv-image-browser @selected="addFile($event)"></mv-image-browser>
                <label class="btn btn-sm btn-primary">
                    <mv-uploader ref="uploader" @upload-done="addFile($event)" accept="*/*" any></mv-uploader>
                    <icon name="file"></icon>
                </label>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-md-4">

            </div>
            <div class="col-md-6">
                <mv-attachment v-for="img in model.attachments" :key="img.id" :attachment="img" can-remove @remove="removeFile">
                </mv-attachment>
            </div>
        </div>
    </form>
</div>
</template>



// WEBPACK FOOTER //
// src/components/forms/SupporterForm.vue